import { createFileRoute } from "@tanstack/react-router";
import { Entities } from "@/components/Entities";

function RouteComponent() {
  return <Entities />;
}

export const Route = createFileRoute("/_authenticated/entities/")({
  component: RouteComponent,
  staticData: { page: "entities" },
});
